import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthenticationService, CommonPlatformService, Platform, CommonUtil } from 'psd-common';

@Component({
    selector: 'central-login-login-forgot-password',
    templateUrl: 'central-login-forgot-password.component.html'
})
export class CentralLoginForgotPasswordComponent implements OnInit {
    public forgotPasswordForm: FormGroup;
    public submitted: boolean = false;
    public resetMailSent: boolean = false;
    public platformPrefix: string;
    public currentPlatform: Platform;
    public submitting: boolean = false;
    public requestFailure: boolean = false;
    public email: string;

    constructor(@Inject(DOCUMENT) private document: Document,
                private renderer: Renderer2,
                private router: Router,
                private route: ActivatedRoute,
                private formBuilder: FormBuilder,
                private platformService: CommonPlatformService,
                private authenticationService: AuthenticationService) {}

    ngOnInit() {
        this.renderer.addClass(this.document.body, 'login');

        this.forgotPasswordForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
        }, {
        });

        this.route.queryParams.subscribe(_params => {
            this.platformPrefix = _params.platform;
            this.email = _params.email;

            if(this.platformPrefix) {
                this.platformService.getExternalPlatformDetails(this.platformPrefix).subscribe(_platform => {
                    this.currentPlatform = _platform;
                });
            }

            if(this.email) {
                this.forgotPasswordForm.setValue({
                    'email' : this.email
                });
            }
        });
    }

    get form() { return this.forgotPasswordForm.controls; }

    send() {
        let json = JSON.parse(JSON.stringify(this.forgotPasswordForm.value, null, 4));
        this.submitting = true;
        this.submitted = true;

        // stop here if form is invalid
        if (this.forgotPasswordForm.invalid) {
            this.submitting = false;
            return;
        }

        this.authenticationService.forgotPassword(json.email, this.currentPlatform?.id).subscribe(_result => {
           this.resetMailSent = true;
           this.submitting = false;
        }, _error => {
            this.submitting = false;
            this.requestFailure = true;
        });
    }
}
